import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  // Sample blog posts data - you can replace this with API calls later
  const latestPosts = [
    {
      id: 1,
      title: 'Building Better Sleep Habits',
      excerpt: 'Learn how to improve your sleep quality with these practical tips and create a bedtime routine that actually works.',
      date: 'January 5, 2026',
      category: 'Mental Health',
      slug: 'building-better-sleep-habits'
    },
    {
      id: 2,
      title: '5 Quick Breakfast Recipes Under 10 Minutes',
      excerpt: 'Start your day right with these simple, nutritious breakfast recipes that are perfect for busy mornings.',
      date: 'January 3, 2026',
      category: 'Recipes',
      slug: '5-quick-breakfast-recipes'
    },
    {
      id: 3,
      title: 'Getting Started with Home Brewing',
      excerpt: 'Discover the art of brewing your own beer at home. A complete beginner\'s guide to this rewarding hobby.',
      date: 'December 28, 2025',
      category: 'Hobbies',
      slug: 'getting-started-home-brewing'
    },
    {
      id: 4,
      title: 'The Ultimate Guide to Laundry',
      excerpt: 'Master the basics of laundry with our comprehensive guide covering everything from sorting to stain removal.',
      date: 'December 20, 2025',
      category: 'Life Tips',
      slug: 'ultimate-guide-to-laundry'
    },
    {
      id: 5,
      title: 'Managing Stress in Your Daily Life',
      excerpt: 'Practical strategies to identify, manage, and reduce stress in your everyday routine.',
      date: 'December 15, 2025',
      category: 'Mental Health',
      slug: 'managing-stress-daily-life'
    },
    {
      id: 6,
      title: 'One-Pot Pasta Recipes for Easy Cleanup',
      excerpt: 'Delicious pasta dishes that cook in one pot, making cleanup a breeze. Perfect for weeknight dinners.',
      date: 'December 10, 2025',
      category: 'Recipes',
      slug: 'one-pot-pasta-recipes'
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Your Bachelor's Guidebook</h1>
          <p>Master mental health, quick meals, and discover new hobbies.<br />Everything you need to thrive on your own.</p>
          <a href="#latest-posts" className="hero-button">Start Reading</a>
        </div>
      </section>

      {/* Category Cards Section */}
      <section className="categories-section">
        <div className="content-wrapper">
          <h2 className="section-title">Your Guide To Better Living</h2>
          <p className="section-subtitle">Find exactly what you need to improve your bachelor lifestyle</p>

          <div className="category-grid">
            {/* Mental Health */}
            <div className="category-card">
              <span className="category-icon">🧠</span>
              <h3>Mental Health</h3>
              <p>Self-care tips, sleep strategies, and daily routines for better mental wellbeing</p>
              <Link to="/mental-health" className="category-button">Browse Articles</Link>
            </div>

            {/* Life Tips */}
            <div className="category-card">
              <span className="category-icon">💡</span>
              <h3>Life Tips</h3>
              <p>Practical advice for everyday living, from cleaning to time management</p>
              <Link to="/life-tips" className="category-button">Get Tips</Link>
            </div>

            {/* Quick Recipes */}
            <div className="category-card">
              <span className="category-icon">🍳</span>
              <h3>Quick Recipes</h3>
              <p>Easy meal preps and quick recipes perfect for busy bachelors</p>
              <Link to="/recipes" className="category-button">View Recipes</Link>
            </div>

            {/* Hobby Kits */}
            <div className="category-card">
              <span className="category-icon">🎯</span>
              <h3>Hobby Kits</h3>
              <p>Startup guides for new hobbies and passions to enrich your life</p>
              <Link to="/hobbies" className="category-button">Start a Hobby</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Posts Section */}
      <section className="latest-posts-section" id="latest-posts">
        <div className="content-wrapper">
          <h2 className="section-title">Latest Articles</h2>
          <p className="section-subtitle">Fresh insights and practical tips for better bachelor living</p>

          <div className="posts-grid">
            {latestPosts.map((post) => (
              <article key={post.id} className="post-card">
                <div className="post-thumbnail-link">
                  <div className="post-thumbnail" style={{
                    background: '#E8DFD4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '3rem'
                  }}>
                    {post.category === 'Mental Health' && '🧠'}
                    {post.category === 'Recipes' && '🍳'}
                    {post.category === 'Hobbies' && '🎯'}
                    {post.category === 'Life Tips' && '💡'}
                  </div>
                </div>

                <div className="post-content">
                  <h3 className="post-title">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h3>

                  <div className="post-excerpt">
                    {post.excerpt}
                  </div>

                  <div className="post-meta">
                    <span>📅 {post.date}</span>
                    <span>📂 {post.category}</span>
                  </div>

                  <Link to={`/blog/${post.slug}`} className="read-more">Read More &rarr;</Link>
                </div>
              </article>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/blog" className="hero-button">View All Posts</Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
